/**
 * memoryContextEngine.js — Re Leve IA (Etapa 4)
 * Busca e estrutura memórias simuladas do cliente.
 * Nunca inventa restrição alimentar que não foi declarada.
 */

import memoriaData from '../data/memoria.json';

const RESTRICTION_KEYWORDS = ['sem_lactose', 'sem_gluten', 'low_carb', 'vegetariano', 'vegano', 'celiaco'];
const GOAL_KEYWORDS = ['organizar_semana', 'emagrecer', 'rotina_saudavel', 'controle_calorico'];

function parseMemoryValue(valor) {
  if (!valor) return null;
  const v = valor.toLowerCase().replace(/\s+/g, '_');
  return v;
}

export function getCustomerMemoryContext(clienteId) {
  if (!clienteId) {
    return {
      memories: [],
      declaredRestrictions: [],
      declaredGoals: [],
      preferredChannel: '',
      calorieInterest: '',
      subscriptionInterest: '',
      notesForBot: [],
      hasSimulatedMemory: false,
    };
  }

  const customerMemories = memoriaData.filter(m => m.clienteId === clienteId);

  if (customerMemories.length === 0) {
    return {
      memories: [],
      declaredRestrictions: [],
      declaredGoals: [],
      preferredChannel: '',
      calorieInterest: '',
      subscriptionInterest: '',
      notesForBot: [],
      hasSimulatedMemory: false,
    };
  }

  const declaredRestrictions = [];
  const declaredGoals = [];
  let preferredChannel = '';
  let calorieInterest = '';
  let subscriptionInterest = '';
  const notesForBot = [];

  for (const mem of customerMemories) {
    if (mem.podeUsarParaPersonalizar !== 'Sim (após consentimento)') continue;

    const tipo = (mem.tipoDeInformacao || '').toLowerCase();
    const valor = parseMemoryValue(mem.valorEstruturado || '');
    const conteudo = mem.informacaoAprendida || '';

    if (tipo.includes('restricao')) {
      if (valor && RESTRICTION_KEYWORDS.some(k => valor.includes(k.replace('_', '')))) {
        declaredRestrictions.push({
          restriction: valor,
          conteudo,
          confidence: mem.nivelDeConfianca || 'Média',
          isSimulated: true,
        });
      }
    } else if (tipo.includes('objetivo')) {
      if (valor && GOAL_KEYWORDS.some(k => valor.includes(k.replace('_', '')))) {
        declaredGoals.push({
          goal: valor,
          conteudo,
          confidence: mem.nivelDeConfianca || 'Média',
          isSimulated: true,
        });
      }
    } else if (tipo.includes('canal')) {
      preferredChannel = conteudo;
    } else if (tipo.includes('calorico') || tipo.includes('caloria')) {
      calorieInterest = conteudo;
    } else if (tipo.includes('assinatura') || tipo.includes('recorrencia')) {
      subscriptionInterest = conteudo;
    }

    notesForBot.push(`[${mem.tipoDeInformacao}] ${conteudo} (confiança: ${mem.nivelDeConfianca || '?'})`);
  }

  return {
    memories: customerMemories.map(m => ({
      id: m.idInteracao,
      tipo: m.tipoDeInformacao,
      conteudo: m.informacaoAprendida,
      confidence: m.nivelDeConfianca,
      isSimulated: true,
    })),
    declaredRestrictions,
    declaredGoals,
    preferredChannel,
    calorieInterest,
    subscriptionInterest,
    notesForBot,
    hasSimulatedMemory: true,
  };
}
